import { createAction } from '@reduxjs/toolkit'
import { projectConfigClear } from 'redux/action.types'
import ProjectConfigReducer from './ProjectConfig.reducer'

export const clearProjectConfigState = createAction(projectConfigClear)

export default ProjectConfigReducer
